import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FaSadTear } from 'react-icons/fa';
import { ImCheckboxChecked, ImCheckboxUnchecked, ImCheckmark } from 'react-icons/im';
import { MdAdd, MdEdit, MdClose } from 'react-icons/md';

import {
  Container,
  Title,
  Buttons,
  AddButton,
  ContainerMethodsList,
  ContainerMethod,
  ContainerMethodData,
  ContainerMethodNoData,
  ButtonContent,
  CardButton,
  CardNumber,
  CardName,
  PayDeliveryButton,
} from './styles';

import { StoreState } from '../../store/createStore';
import { findMethods, findMethodsAll } from '../../store/modules/parameter/actions';
import Loading from '../Loading';
import { useTranslation } from '../../hooks/useTranslation';
import { usePaymentMethod } from '../../hooks/usePaymentMethod';
import PaymentCreateType from './PaymentCreateType';
import { config } from '../../config';
import LogoBrand from '../ReactCreditCard/logoBrand';

interface AccountPaymentProps {
  handledSetMethodSelectExt?: (methodId: number, methodTypeId: number) => void;
  isCheckout?: boolean;
}

const AccountPayment: React.FC<AccountPaymentProps> = ({ isCheckout, handledSetMethodSelectExt }: AccountPaymentProps) => {
  const dispatch = useDispatch();
  const { onTranslation: t } = useTranslation();
  const { methodsAll, methods, loading, payOnDelivery, methodsType } = useSelector((state: StoreState) => state.parameter);
  const {
    handledMethodAdd,
    handledMethodEdit,
    handledMethodFavorite,
    handledMethodRemove,
    handledPayOnDelivery,
    openViewCreatePayment,
    handledSetMethod,
    methodSelected,
    onSetOpenViewCreatePayment,
    values
  } = usePaymentMethod();

  useEffect(() => {
    dispatch(findMethodsAll());
    dispatch(findMethods());
  }, [dispatch]);

  if (openViewCreatePayment) {
    return (
      <PaymentCreateType
        handledSetMethod={handledSetMethod}
        methodSelected={methodSelected}
        onSetOpenViewCreatePayment={onSetOpenViewCreatePayment}
        values={values}
      />
    )
  }

  if (loading) {
    return (
      <Container bJustifyContentCenter>
        <Loading size={160} bShowText />
      </Container>
    )
  }

  return (
    <Container>
      <Title>
        <span>{t('main.component_account_payment.my_cards')}</span>
        <Buttons>
          <AddButton title={t('main.component_account_payment.add_card')} onClick={handledMethodAdd}>
            <MdAdd size={28} />
            <span>{t('main.globals.add')}</span>
          </AddButton>
          {
            isCheckout && (<PayDeliveryButton
              checked={payOnDelivery}
              title={t('main.component_account_payment.pay_on_delivery')}
              onClick={handledPayOnDelivery}>
              <ImCheckmark size={20} />
              <span>{t('main.component_account_payment.pay_on_delivery')}</span>
            </PayDeliveryButton>)
          }
        </Buttons>
      </Title>
      <ContainerMethodsList>
        {methods && methods.length > 0 &&
          methods.map(method => (
            <ContainerMethod key={method.id && method.id}>
              <ContainerMethodData>
                <CardButton title={t('main.component_account_payment.select_bookmarks')}
                  onClick={() => {
                    if (handledSetMethodSelectExt) {
                      handledSetMethodSelectExt(method.id as number, method.media_id as number)
                    } else {
                      handledMethodFavorite(method.id ? method.id : 0, method.media_id ? method.media_id : 0)
                    }
                  }
                  }
                >
                  {method.selected ? <ImCheckboxChecked color="var(--primary)" size={28} /> : <ImCheckboxUnchecked color="#ccc" size={28} />}
                </CardButton>
                <div>
                  <div>
                    <LogoBrand brand={method.card_brand || ''}/>
                  </div>
                  <div>
                    <CardNumber><span>{'****.****.****.' + method.card_last_four}</span></CardNumber>
                    <CardName><span> {method.full_name} - {method.expiry_date} - {
                      config.isNewLayoutChosePayment ? (
                        methodsType.options.cards?.find(methodall => methodall.media_id === method.media_id)?.name || ''
                      ) : (
                        methodsAll?.find(methodall => methodall.media_id === method.media_id)?.name || ''
                      )
                    }</span></CardName>
                  </div>
                </div>
              </ContainerMethodData>
              <ButtonContent>
                <CardButton title={t('main.component_account_payment.change_card')} onClick={() => handledMethodEdit(method)}>
                  <MdEdit color="var(--btn-finish)" size={28} />
                </CardButton>
                <CardButton title={t('main.component_account_payment.remove_card')} onClick={() => handledMethodRemove(method.id ? method.id : 0)}>
                  <MdClose color="var(--btn-canc)" size={28} />
                </CardButton>
              </ButtonContent>
            </ContainerMethod>
          ))
        }
        {methods && methods.length === 0 && (
          <ContainerMethodNoData>
            <span>{t('main.component_account_payment.without_card')} <FaSadTear color="var(--primary)" size={22} /></span>
          </ContainerMethodNoData>
        )}
      </ContainerMethodsList>
    </Container>
  );
}

export default AccountPayment;
